import { useCallback, useEffect, useState } from 'react';

type QueryParam = {
  key: string;
  value: string;
};

type UseToggleStateOnMatchQueryParam = {
  setQueryParam: (key: string, value: string) => void;
  removeQueryParam: (key: string) => void;
  matchesQueryParam: () => boolean;
  queryParam: QueryParam;
};

export const useToggleStateOnMatchQueryParam = ({
  queryParam,
  matchesQueryParam,
  removeQueryParam,
  setQueryParam,
}: UseToggleStateOnMatchQueryParam) => {
  const [isToggleOn, setToggle] = useState<boolean>(false);

  useEffect(() => {
    if (matchesQueryParam()) {
      setToggle(true);
    } else {
      setToggle(false);
    }
  }, [matchesQueryParam]);

  const handleToggleOn = useCallback(() => {
    setQueryParam(queryParam.key, queryParam.value);
    setToggle(true);
  }, [queryParam.key, queryParam.value, setQueryParam]);

  const handleToggleOff = useCallback(() => {
    removeQueryParam(queryParam.key); // Clears the query string
    setToggle(false);
  }, [queryParam.key, removeQueryParam]);

  return { isToggleOn, handleToggleOn, handleToggleOff };
};
